<template>

    <v-button id="btn-google" btn-style="google" data-onsuccess="onSignIn" :disabled="loading">
        <i class="fab fa-google"></i>
        <v-loader v-if="loading" size="sm" />
        <span v-else>Continue with Google</span>
    </v-button>

</template>

<style scoped lang="scss">

    #btn-google {
        display: flex !important;
        i {
            align-items: center;
            color: #DB4437;
            display: flex;
            font-size: 16px;
            justify-content: center;
            left: 0;
            margin: 0 15px;
            height: 100%;
            position: absolute;
            top: 0;
        }
        .loader {
            margin: 0;
        }
    }

</style>

<script>

export default {

    data() {
        return {
            appUrl: process.env.VUE_APP_APP_URL,
            auth2: null,
            loading: false,
            error: null,
        }
    },

    mounted() {
        window.gapi.load('auth2', () => {
            this.auth2 = window.gapi.auth2.init({
                client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
            });
            this.attachSignin(document.getElementById('btn-google'));
        });
    },

    methods: {

        attachSignin(el) {
            this.auth2.attachClickHandler(el, {}, (user) => {
                this.loading = true;
                let token = user.getAuthResponse().id_token;
                window.location.href = `${this.appUrl}/signup?id_token=${token}`;
            }, () => {
                this.loading = false;
                this.error = 'Unable to sign in with Google.';
            });
        },

    },

}

</script>
